import { render, staticRenderFns } from "./SetBmdCTD.vue?vue&type=template&id=ef26c3aa&scoped=true&"
import script from "./SetBmdCTD.vue?vue&type=script&lang=js&"
export * from "./SetBmdCTD.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef26c3aa",
  null
  
)

export default component.exports